import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/** Options shape shared by `ish-modal-dialog` (kept separate to avoid circular imports). */
export type PresidioModalChromeOptions = NgbModalOptions & {
  titleText?: string;
  confirmText?: string;
  confirmDisabled?: boolean;
  rejectText?: string;
  icon?: string;
  iconClass?: string;
};

/**
 * Presidio NgbModal chrome — standard for every modal:
 * centered card (`prs-modal` + size token) with dense form controls from
 * `presidio-modals.scss`. Callers may add feature classes (e.g. address form).
 */
export function withPresidioModalChrome(options: PresidioModalChromeOptions): PresidioModalChromeOptions {
  const sizeToken =
    options.size === 'sm'
      ? 'prs-modal--sm'
      : options.size === 'lg'
        ? 'prs-modal--lg'
        : options.size === 'xl'
          ? 'prs-modal--xl'
          : 'prs-modal--md';

  const classes = new Set<string>(['prs-modal', sizeToken]);
  for (const token of (options.windowClass || '').split(/\s+/)) {
    if (token) {
      classes.add(token);
    }
  }

  return {
    ...options,
    centered: options.centered ?? true,
    windowClass: [...classes].join(' '),
  };
}

/** Address create/edit — matches account Addresses modal (`prs-address-form-modal`). */
export function presidioAddressFormModalOptions(options: PresidioModalChromeOptions): PresidioModalChromeOptions {
  const featureClass = 'prs-address-form-modal';
  const existing = options.windowClass || '';
  return withPresidioModalChrome({
    size: 'lg',
    scrollable: true,
    ...options,
    windowClass: existing.includes(featureClass) ? existing : `${featureClass} ${existing}`.trim(),
  });
}
